
  document.addEventListener("DOMContentLoaded", () => {
    const HEADLINE_SELECTOR = '.satisfied-clients-headline';
    const WIDGET_SELECTOR = '#etrusted-product_review_list';
    console.log("Widget", WIDGET_SELECTOR)

    const headline = document.querySelector(HEADLINE_SELECTOR);
    const widget = document.querySelector(WIDGET_SELECTOR);
    console.log("Widget:", widget);

    if (!headline || !widget) return;

    let lastState = null;

    const evaluateVisibility = () => {
      const height = widget.offsetHeight;
      const shouldHide = height < 50;

      if (shouldHide !== lastState) {
        headline.style.display = shouldHide ? 'none' : 'block';
        console.log(`[Review Observer] Height: ${height} | Hide: ${shouldHide}`);
        lastState = shouldHide;
      }
    };

    // initial check
    evaluateVisibility();

    // observe widget size changes
    new ResizeObserver(() => {
      console.log('[Review Observer] Resize detected');
      evaluateVisibility();
    }).observe(widget);

    // Fallback timeout — in case widget renders slowly and no resize triggers
    // setTimeout(() => {
    //   console.log('[Review Observer] Fallback timeout check');
    //   evaluateVisibility();
    // }, 5000);
  });
